'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createActionTypes;

var _ramda = require('ramda');

function createActionTypes(namespace, list) {
  var addNamespace = function addNamespace(type) {
    return '~' + namespace + '/' + type;
  };

  return (0, _ramda.reduce)(function (constants, type) {
    return (0, _ramda.assoc)(type, addNamespace(type), constants);
  }, {}, list);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/zeal-redux-utils/lib/createActionTypes.js
// module id = 1197
// module chunks = 0